module.exports = __webpack_public_path__ + "img/$-y.e7ff9686.svg";